<template>
  <div class="category">
    <app-header/>

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-10">
          <div class="category__info">
            <h1 class="category__title">{{ filteredProducts[0].categoryName }}</h1>
            <p class="category__descr">{{ filteredProducts[0].categoryDescr }}</p>
          </div>
        </div>
        <div class="col-xl-10">
          <div class="row">
            <ItemCard v-for="(product, index) in filteredProducts" :key="index" :product="product"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import ItemCard from "@/components/ItemCard.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "Category",
  components: {
    ItemCard,
    "app-header": Header
  },
  metaInfo() {
    return {
      title: this.filteredProducts[0].categoryName,
      meta: [
        {
          name: "description",
          content: this.filteredProducts[0].categoryDescr,
          vmid: "description"
        },
        {
          property: "og:title",
          content: this.filteredProducts[0].categoryName,
          vmid: "og:title"
        },
        {
          property: "og:description",
          content: this.filteredProducts[0].categoryDescr,
          vmid: "og:description"
        }
      ]
    };
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("products", ["filteredProducts"])
  },
  beforeRouteUpdate(to, from, next) {
    this.setFilter(to.params.id);
    return next();
  },
  mounted() {
    this.setFilter(this.$route.params.id);
  },
  methods: {
    ...mapActions("products", ["setFilter"])
  }
};
</script>
